import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "v-tasks__header" }
const _hoisted_2 = { class: "v-tasks__body" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "v-tasks__date-label" }
const _hoisted_5 = { class: "company__name" }
const _hoisted_6 = { class: "app" }
const _hoisted_7 = { class: "v-users__badge" }
const _hoisted_8 = { class: "v-users__badge" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "action" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "icon"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "v-tasks__loading-more"
}
const _hoisted_15 = {
  key: 1,
  class: "v-tasks__end"
}
const _hoisted_16 = {
  key: 0,
  class: "new-modal info"
}
const _hoisted_17 = {
  key: 1,
  class: "info"
}
const _hoisted_18 = {
  key: 2,
  class: "info"
}
const _hoisted_19 = { class: "description__footer" }

import { onMounted, ref, computed, watch, onUnmounted } from "vue";
import {
  SearchMd,
  ChevronDown,
  ReverseLeft,
  Trash01,
  Eye,
} from "utruckin-icons";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import CommonSearch from "@/components/common/CommonSearch.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import CommonStatus from "@/components/common/CommonStatus.vue";
import { useTaskStore } from "@/features/tasks/task.store";
import { useTeamStore } from "@/features/teams/team.store";
import { useWorkTypeStore } from "@/features/work-types/work-type.store";
import { ITaskData } from "@/features/tasks/task.types";
import { ITeam } from "@/features/teams/team.types";
import { IWorkType } from "@/features/work-types/work-type.types";
import { TaskStatus } from "@/features/tasks/task.enum";
import { DateTime } from "luxon";
import { useCompanyStore } from "@/features/company/company.store";
import { ICompany } from "@/features/company/company.types";
import { useUserStore } from "@/features/users/user.store";
import { useDriverStore } from "@/features/drivers/drivers.store";
import { useNotification } from "@/utils/notification";
import { useAppStore } from "@/store/app.store";
import { useArchiveStore } from "@/features/archive/archive.store";
import CommonInput from "@/components/common/CommonInput.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import CommonModal from "@/components/common/CommonModal.vue";
import { IUser } from "@/features/users/user.types";
import CustomSearchDropdown from "@/components/custom/CustomSearchDropdown.vue";

const PAGE_SIZE = 50;

export default /*@__PURE__*/_defineComponent({
  __name: 'ArchiveView',
  setup(__props) {

const taskStore = useTaskStore();
const teamStore = useTeamStore();
const workTypeStore = useWorkTypeStore();
const companyStore = useCompanyStore();
const usersStore = useUserStore();
const driverStore = useDriverStore();
const appStore = useAppStore();
const archiveStore = useArchiveStore();
const { pushNotification } = useNotification();

const tasks = ref<ITaskData[]>([]);
const teams = ref<ITeam[]>([]);
const companies = ref<ICompany[]>([]);
const workTypes = ref<IWorkType[]>([]);
const problems = ref<IWorkType[]>([]);
const users = ref<IUser[]>([]);

const tasksLoading = ref(false);
const teamLoading = ref(false);
const userLoading = ref(false);
const workTypeLoading = ref(false);
const companyLoading = ref(false);

const team = ref<string>("");
const user = ref<string>("");
const status = ref<string>("");
const problem = ref<string>("");
const search = ref<string>("");
const isAdmin = ref<boolean>(false);

const isModalOpen = ref<boolean>(false);
const modalType = ref<"info" | "unarchive" | "delete">("info");
const modalItem = ref<ITaskData | null>(null);
const modalReason = ref<string>("");

let searchTimer: ReturnType<typeof setTimeout> | null = null;

let searchFilterProblemTimer: ReturnType<typeof setTimeout> | null = null;
let searchFilterUserTimer: ReturnType<typeof setTimeout> | null = null;

const collapsedDates = ref<Record<string, boolean>>({});
const collapsedShifts = ref<Record<string, boolean>>({});

const page = ref(1);
const hasMore = ref(true);
const isLoadingMore = ref(false);
const scrollContainer = ref<HTMLElement | null>(null);
const sentinel = ref<HTMLElement | null>(null);
let observer: IntersectionObserver | null = null;

const STATUS_COLORS: Record<TaskStatus, string> = {
  [TaskStatus.NEW]: "--color-system-blue",
  [TaskStatus.INFORM]: "--color-system-grey",
  [TaskStatus.IN_PROGRESS]: "--color-system-orange",
  [TaskStatus.ON_HOLD]: "--color-system-yellow",
  [TaskStatus.DONE]: "--color-system-green",
  [TaskStatus.QA_FAILED]: "--color-system-red",
  [TaskStatus.CLOSED]: "--color-system-green",
};

const problemFilterItems = computed(() =>
  (workTypes.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
  }))
);

const userFilterItems = computed(() =>
  (users.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
  }))
);

const filteredHeaders = computed(() => {
  if (archiveStore.commonFilter.team_id) {
    return [
      {
        name: "id",
        label: "No",
        width: "3%",
      },
      {
        name: "company",
        label: "Company",
        width: "14%",
      },
      {
        name: "drivers",
        label: "Drivers",
        width: "14%",
      },
      {
        name: "users",
        label: "User",
        width: "13%",
      },
      {
        name: "date",
        label: "Start time",
        width: "6%",
      },
      {
        name: "completed_time",
        label: "End time",
        width: "6%",
      },
      {
        name: "points_awarded",
        label: "KPI",
        width: "3%",
      },
      {
        name: "status",
        label: "Status",
        width: "9%",
      },
      {
        name: "problems",
        label: "Problems",
        width: "24%",
      },
      {
        name: "actions",
        label: "",
        width: "8%",
      },
    ];
  } else {
    return [
      {
        name: "id",
        label: "No",
        width: "3%",
      },
      {
        name: "company",
        label: "Company",
        width: "14%",
      },
      {
        name: "drivers",
        label: "Drivers",
        width: "14%",
      },
      {
        name: "team",
        label: "Team",
        width: "5%",
      },
      {
        name: "users",
        label: "User",
        width: "13%",
      },
      {
        name: "date",
        label: "Start time",
        width: "6%",
      },
      {
        name: "completed_time",
        label: "End time",
        width: "6%",
      },
      {
        name: "points_awarded",
        label: "KPI",
        width: "3%",
      },
      {
        name: "status",
        label: "Status",
        width: "9%",
      },
      {
        name: "problems",
        label: "Problems",
        width: "19%",
      },
      {
        name: "actions",
        label: "",
        width: "8%",
      },
    ];
  }
});

const formatStatusLabel = (key: string) =>
  key.replace(/_/g, "_").replace(/\b\w/g, (c) => c.toUpperCase());

const statusItems = (
  Object.keys(TaskStatus) as Array<keyof typeof TaskStatus>
).map((key) => ({
  value: TaskStatus[key],
  name: formatStatusLabel(key),
  color: STATUS_COLORS[TaskStatus[key]],
}));

const hasUserHasAction = (item: ITaskData) => {
  return (
    usersStore.userProfile &&
    (usersStore.userProfile.id == item.assignee_id ||
      usersStore.userProfile.role == "admin" ||
      usersStore.userProfile.role == "supervisor")
  );
};

const getStatus = (qaStatus: string) => {
  const key = (Object.keys(TaskStatus) as Array<keyof typeof TaskStatus>).find(
    (k) => TaskStatus[k] === qaStatus
  );
  return key ? formatStatusLabel(key) : null;
};

const toggleDate = (date: string) => {
  collapsedDates.value[date] = !collapsedDates.value[date];
};

const toggleShift = (date: string, shift: string) => {
  const key = `${date}::${shift}`;
  collapsedShifts.value[key] = !collapsedShifts.value[key];
};

const isDateCollapsed = (date: string) => collapsedDates.value[date];
const isShiftCollapsed = (date: string, shift: string) =>
  collapsedShifts.value[`${date}::${shift}`];

const groupedByDate = computed(() => {
  const dateMap = new Map<string, Map<string, ITaskData[]>>();

  for (const task of tasks.value) {
    const date = task.created_time
      ? DateTime.fromISO(task.created_time, { zone: "utc" })
          .setZone("America/New_York")
          .toFormat("yyyy-MM-dd")
      : "Unknown";

    const shift = task.shift_name ?? "Unknown Shift";

    if (!dateMap.has(date)) {
      dateMap.set(date, new Map());
    }

    const shiftMap = dateMap.get(date)!;

    if (!shiftMap.has(shift)) {
      shiftMap.set(shift, []);
    }

    shiftMap.get(shift)!.push(task);
  }

  return Array.from(dateMap.entries()).map(([date, shiftMap]) => {
    const shiftGroups = Array.from(shiftMap.entries()).map(
      ([label, items]) => ({
        label,
        items,
      })
    );

    return { date, shiftGroups };
  });
});

function datepickerToUtcDateOnly(d: string | Date | null | undefined) {
  if (!d) return "";

  const date =
    typeof d === "string"
      ? DateTime.fromISO(d, { zone: "utc" })
      : DateTime.fromJSDate(d, { zone: "utc" });

  return date.setZone("America/New_York").toFormat("HH:mm:ss");
}

// --- pagination helpers ------------------------------------------------------
const fetchArchives = async (opts: { append: boolean }) => {
  archiveStore.commonFilter.page = page.value;
  archiveStore.commonFilter.per_page = PAGE_SIZE;

  const loadingRef = opts.append ? isLoadingMore : tasksLoading;

  await archiveStore.getArchives(loadingRef, (data: any) => {
    if (!data) return;

    const items: ITaskData[] = data.items ?? [];

    tasks.value = opts.append ? [...tasks.value, ...items] : items;

    hasMore.value =
      data.has_more !== undefined ? data.has_more : items.length === PAGE_SIZE;
  });
};

const resetAndFetch = async () => {
  page.value = 1;
  hasMore.value = true;
  await fetchArchives({ append: false });
};

const loadMore = async () => {
  if (tasksLoading.value || isLoadingMore.value || !hasMore.value) return;
  page.value += 1;
  await fetchArchives({ append: true });
};
// -------------------------------------------------------------------------------

const getList = async () => {
  const [fetchedTeams, fetchedWorkTypes, fetchedCompanies, fetchUsers] =
    await Promise.all([
      teamStore.getTeams(teamLoading),
      workTypeStore.getWorkTypes(workTypeLoading),
      companyStore.getCompanies(companyLoading),
      usersStore.getUsers(userLoading),
    ]);

  await resetAndFetch();

  teams.value = fetchedTeams;
  workTypes.value = fetchedWorkTypes;
  companies.value = fetchedCompanies.items;
  problems.value = fetchedWorkTypes;
  users.value = fetchUsers;
};

const formatToEdt = (date: any) => {
  if (!date) return "";

  return date.split("T")[1] == "11:00:00.000Z"
    ? DateTime.fromISO(date, { zone: "utc" })
        .setZone("America/New_York")
        .toFormat("LLL d")
    : DateTime.fromISO(date, { zone: "utc" })
        .setZone("America/New_York")
        .toFormat("LLL d, HH:mm ZZZZ");
};

const tooltipContent = (list: any[]) =>
  list
    ?.map((item) => `<p>${item.label} - ${formatToEdt(item.date)}</p>`)
    ?.join("");

const openModal = (type: "info" | "unarchive" | "delete", item: ITaskData) => {
  modalType.value = type;
  modalItem.value = item;
  isModalOpen.value = true;
  modalReason.value = "";
};

const closeModal = () => {
  modalType.value = "info";
  modalItem.value = null;
  isModalOpen.value = false;
  modalReason.value = "";
};

const saveModal = async () => {
  if (modalType.value === "unarchive") {
    if (!modalItem.value) return;
    await archiveStore.unarchiveTask(
      tasksLoading,
      modalItem.value?.id,
      modalReason.value,
      async (data: any) => {
        if (data) {
          pushNotification("Successfully unarchived", "success");
          closeModal();
          await getList();
        }
      }
    );
  } else if (modalType.value === "delete") {
    if (!modalItem.value) return;
    await archiveStore.deleteTask(
      tasksLoading,
      modalItem.value.id,
      async (data: any) => {
        if (data) {
          pushNotification("Successfully deleted", "success");
          closeModal();
          await getList();
        }
      }
    );
  }
};

const searchFilterWorkType = (val: string) => {
  if (searchFilterProblemTimer) clearTimeout(searchFilterProblemTimer);
  searchFilterProblemTimer = setTimeout(async () => {
    workTypeStore.commonFilter.search = val;
    const [fetchedWorkTypes] = await Promise.all([
      workTypeStore.getWorkTypes(workTypeLoading),
    ]);

    workTypes.value = fetchedWorkTypes;
  }, 400);
};

const searchFilterUser = (val: string) => {
  if (searchFilterUserTimer) clearTimeout(searchFilterUserTimer);
  searchFilterUserTimer = setTimeout(async () => {
    usersStore.commonFilter.q = val;
    const [fetchedUsers] = await Promise.all([
      usersStore.getUsers(userLoading),
    ]);

    users.value = fetchedUsers;
  });
};

onMounted(async () => {
  companyStore.commonFilter.search = "";
  driverStore.commonFilter.search = "";
  workTypeStore.commonFilter.search = "";

  if (usersStore.userProfile?.role === "admin") {
    isAdmin.value = true;
  }

  if (archiveStore.commonFilter.search) {
    search.value = archiveStore.commonFilter.search;
  }

  if (archiveStore.commonFilter.team_id) {
    team.value = archiveStore.commonFilter.team_id;
  } else {
    if (usersStore.userProfile && usersStore.userProfile.team_id) {
      team.value = usersStore.userProfile.team_id;
      companyStore.commonFilter.team_id = usersStore.userProfile.team_id;
      archiveStore.commonFilter.team_id = usersStore.userProfile.team_id;
    }
  }

  if (archiveStore.commonFilter.status) {
    status.value = archiveStore.commonFilter.status;
  }

  if (archiveStore.commonFilter.work_type_id) {
    problem.value = archiveStore.commonFilter.work_type_id;
  }
  await getList();

  observer = new IntersectionObserver(
    (entries) => {
      if (entries[0]?.isIntersecting) loadMore();
    },
    { root: scrollContainer.value, rootMargin: "200px" }
  );
  if (sentinel.value) observer.observe(sentinel.value);
});

watch(
  () => search.value,
  async (val) => {
    if (tasksLoading.value || isLoadingMore.value) return;
    if (searchTimer) clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      archiveStore.commonFilter.search = val;
      await resetAndFetch();
    }, 400);
  },
  {
    immediate: false,
  }
);

watch(
  () => user.value,
  async (val: string) => {
    if (tasksLoading.value || isLoadingMore.value) return;
    archiveStore.commonFilter.assignee_id = val;
    await resetAndFetch();
  },
  { immediate: false }
);

watch(
  () => team.value,
  async (val: string) => {
    if (tasksLoading.value || isLoadingMore.value) return;
    archiveStore.commonFilter.team_id = val;
    await resetAndFetch();
  },
  { immediate: false }
);

watch(
  () => status.value,
  async (val: string) => {
    if (tasksLoading.value || isLoadingMore.value) return;
    archiveStore.commonFilter.status = val;
    await resetAndFetch();
  },
  { immediate: false }
);

watch(
  () => problem.value,
  async (val: string) => {
    if (tasksLoading.value || isLoadingMore.value) return;
    archiveStore.commonFilter.work_type_id = val;
    await resetAndFetch();
  },
  { immediate: false }
);

watch(
  () => appStore.refreshKey,
  () => {
    getList();
  },
  {
    immediate: false,
  }
);

onUnmounted(() => {
  observer?.disconnect();
  archiveStore.clearFilter();
  workTypeStore.clearFilter();
  usersStore.clearFilter();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "v-tasks",
    ref_key: "scrollContainer",
    ref: scrollContainer
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CommonSearch, {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
        icon: _unref(SearchMd),
        placeholder: 'Search',
        clearable: ""
      }, null, 8, ["modelValue", "icon"]),
      _createVNode(CommonDropdown, {
        modelValue: team.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((team).value = $event)),
        items: teams.value.map((t) => ({ value: t.id, name: t.name })),
        label: "Team",
        position: "bottom",
        dropdownFullWidth: "",
        clearable: ""
      }, null, 8, ["modelValue", "items"]),
      _createVNode(CustomSearchDropdown, {
        modelValue: user.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user).value = $event)),
        items: userFilterItems.value,
        label: "User",
        position: "bottom",
        clearable: "",
        dropdownFullWidth: "",
        maxWidth: "200px",
        onSearch: searchFilterUser
      }, null, 8, ["modelValue", "items"]),
      _createVNode(CommonDropdown, {
        modelValue: status.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((status).value = $event)),
        items: _unref(statusItems),
        label: "Status",
        position: "bottom",
        clearable: ""
      }, null, 8, ["modelValue", "items"]),
      _createVNode(CustomSearchDropdown, {
        modelValue: problem.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((problem).value = $event)),
        items: problemFilterItems.value,
        label: "Problem",
        position: "bottom",
        clearable: "",
        dropdownFullWidth: "",
        maxWidth: "400px",
        onSearch: searchFilterWorkType
      }, null, 8, ["modelValue", "items"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedByDate.value, (dateGroup, dateIndex) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: dateIndex }, [
          _createElementVNode("div", {
            class: _normalizeClass(["v-tasks__date-row", { 'is-collapsed': isDateCollapsed(dateGroup.date) }]),
            onClick: ($event: any) => (toggleDate(dateGroup.date))
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(dateGroup.date), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["v-tasks__date-chevron", { 'is-collapsed': isDateCollapsed(dateGroup.date) }])
            }, [
              _createVNode(_unref(ChevronDown), { size: 20 })
            ], 2)
          ], 10, _hoisted_3),
          (!isDateCollapsed(dateGroup.date))
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(dateGroup.shiftGroups, (shiftGroup, shiftIndex) => {
                return (_openBlock(), _createBlock(CommonTable, {
                  key: shiftIndex,
                  headers: filteredHeaders.value,
                  groups: [{ label: shiftGroup.label, items: shiftGroup.items }],
                  loading: tasksLoading.value,
                  collapsed: isShiftCollapsed(dateGroup.date, shiftGroup.label),
                  onToggleGroup: ($event: any) => (toggleShift(dateGroup.date, shiftGroup.label)),
                  isTaskTable: "",
                  dateIndex: dateIndex,
                  shiftIndex: shiftIndex,
                  isAdmin: isAdmin.value,
                  withoutHeader: shiftIndex > 0
                }, {
                  id: _withCtx(({ index }) => [
                    _createElementVNode("span", null, _toDisplayString(index + 1), 1)
                  ]),
                  company: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(item.company_name), 1),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(item.provider_name?.split(" ")[0] || "Hos"), 1)
                    ])
                  ]),
                  drivers: _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(item.driver_name), 1)
                  ]),
                  team: _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(item.team_name), 1)
                  ]),
                  users: _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.assignee_name), 1)
                  ]),
                  date: _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(datepickerToUtcDateOnly(item.created_time)), 1)
                  ]),
                  completed_time: _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(datepickerToUtcDateOnly(item.completed_time) || "-"), 1)
                  ]),
                  status: _withCtx(({ item }) => [
                    (item.status && getStatus(item.status))
                      ? (_openBlock(), _createBlock(CommonStatus, {
                          key: 0,
                          status: getStatus(item.status)!,
                          showActions: false,
                          tooltipContent: 
                    tooltipContent(item.qa_failed_reason_details)
                  
                        }, null, 8, ["status", "tooltipContent"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, "—"))
                  ]),
                  problems: _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.description || item.work_type_name), 1)
                  ]),
                  actions: _withCtx(({ item }) => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        class: "icon",
                        onClick: ($event: any) => (openModal('info', item))
                      }, [
                        _createVNode(_unref(Eye), { size: 14 })
                      ], 8, _hoisted_11),
                      hasUserHasAction
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_unref(ReverseLeft), {
                              size: 14,
                              onClick: ($event: any) => (openModal('unarchive', item))
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      (
                      _unref(usersStore).userProfile?.role === 'super_admin' ||
                      _unref(usersStore).userProfile?.role == 'admin' ||
                      _unref(usersStore).userProfile?.role == 'supervisor'
                    )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "icon",
                            onClick: ($event: any) => (openModal('delete', item))
                          }, [
                            _createVNode(_unref(Trash01), { size: 14 })
                          ], 8, _hoisted_13))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["headers", "groups", "loading", "collapsed", "onToggleGroup", "dateIndex", "shiftIndex", "isAdmin", "withoutHeader"]))
              }), 128))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createElementVNode("div", {
        ref_key: "sentinel",
        ref: sentinel,
        class: "v-tasks__sentinel"
      }, null, 512),
      (isLoadingMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Loading more… "))
        : (!hasMore.value && tasks.value.length && !tasksLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, " No more tasks "))
          : _createCommentVNode("", true)
    ]),
    _createVNode(CommonModal, {
      modelValue: isModalOpen.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isModalOpen).value = $event)),
      title: 
        modalType.value == 'info'
          ? 'Archive reason'
          : modalType.value == 'delete'
          ? 'Delete'
          : 'Unarchive'
      
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(CommonButton, {
            type: "outline",
            label: modalType.value == 'info' ? 'Close' : 'Cancel',
            onClicked: closeModal
          }, null, 8, ["label"]),
          (modalType.value !== 'info')
            ? (_openBlock(), _createBlock(CommonButton, {
                key: 0,
                type: "primary",
                label: modalType.value == 'delete' ? 'Delete' : 'Save',
                onClicked: saveModal
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        (modalType.value == 'unarchive')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(CommonInput, {
                modelValue: modalReason.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modalReason).value = $event)),
                label: "Reason",
                multiline: ""
              }, null, 8, ["modelValue"])
            ]))
          : (modalType.value == 'delete')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, " This will permanently delete this task. You cannot undo this action. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(modalItem.value?.archive_reason || "-"), 1))
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 512))
}
}

})